// extracted by mini-css-extract-plugin
export default {"no-date":"BeREa","noDate":"BeREa","date":"_2mEIU","no-location":"s8PIJ","noLocation":"s8PIJ","location":"_1dzRg"};